<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 16 16"
        fill="none"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.18911 1.80863C8.94402 1.05372 10.1689 1.05303 10.9235 1.80863L14.2227 5.10785C14.9303 5.8156 14.9753 6.93631 14.3555 7.69535L14.2227 7.84222L9.10864 12.9571H14.2211C14.5523 12.9573 14.8211 13.2259 14.8211 13.5571C14.8211 13.8883 14.5523 14.1569 14.2211 14.1571H7.77661C7.75237 14.1571 7.72823 14.1552 7.70474 14.1524C7.6899 14.1535 7.67519 14.1571 7.66021 14.1571H5.22193C5.06285 14.1571 4.91022 14.0937 4.79771 13.9813L1.77349 10.9578C1.01857 10.2029 1.01785 8.97809 1.77349 8.22347L8.18911 1.80863ZM2.62193 9.07191C2.33606 9.35731 2.33516 9.82264 2.62193 10.1094L5.47036 12.9571H7.41177L9.74224 10.625L5.40552 6.28831L2.62193 9.07191ZM10.0743 2.65706C9.78893 2.37124 9.32512 2.37049 9.03833 2.65706L6.25396 5.43988L10.5907 9.7766L13.3751 6.993C13.6606 6.70766 13.6607 6.24378 13.3743 5.95706L10.0743 2.65706Z"
            fill="currentColor"
        />
    </svg>
</template>
